<template>
  <header class="hero-container">
    <div class="hero-split-background">
      <HeadImage :image="rightImage"></HeadImage>

      <div class="hero-half right">
        <div class="gradient-overlay"></div>
      </div>
    </div>
    <div class="hero-content">
      <h1 class="hero-headline">{{ title }}</h1>
      <p class="hero-subheadline">{{ subtitle }}</p>
    </div>
  </header>
</template>

<script>
import HeadImage from '@/components/HeadImage/HeadImage';
export default {
  name: 'HeroSection',
  components: { HeadImage },
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    leftImage: {
      type: String,
      required: true,
    },
    rightImage: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.hero-container {
  height: 1vh;
  min-height: 500px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  overflow: hidden;
  border-radius: 12px;
  color: #fff;
}

.hero-split-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  z-index: 1;
}

.hero-half {
  width: 25%;
  height: 100%;
  background-size: cover;
  background-position: center;
  position: relative;
  transition: transform 0.4s ease-out;
}

.hero-container:hover .hero-half.left {
  transform: scale(1.05) translateX(-2%);
}

.hero-container:hover .hero-half.right {
  transform: scale(1.05) translateX(2%);
}

.gradient-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to top, #3c585d 10%, rgba(26, 26, 28, 0.2) 100%);
}

.hero-content {
  position: relative;
  z-index: 2;
  padding: 2rem;
}

.hero-headline {
  font-family: 'Oswald', sans-serif;
  font-size: 2.6rem;
  font-weight: 900;
  text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.8);
  max-width: 900px;
  line-height: 1.1;
  margin: 0;
}

.hero-subheadline {
  font-size: 1.3rem;
  color: #b8b6b6;
  padding: 20px;
  background-color: rgba(41, 30, 30, 0.5);
  margin-top: 1rem;
  max-width: 600px;
}

@media (max-width: 768px) {
  .hero-headline {
    font-size: 2.8rem;
  }
}
</style>
